import "./Dashboard.scss";

// import rison from "rison";
import React, { useEffect, useRef } from "react";

import { DashboardProps } from "./Dashboard.types";
import { embedDashboard, EmbeddedDashboard } from "./Embedded";
import { formatNativeFilter } from "./Embedded/NativeFilter";

const Dashboard = ({
  uuid,
  domain,
  dataProvider,
  guestToken,
  nativeFilters,
  autosize = false,
  placeholder = false,
  uiConfig = {
    hideTitle: true,
  },
  /*  **VYMO-AUTH-TOKEN  */
  vymoAuthToken,
}: DashboardProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = React.useState(true);

  function encodeValue(value: any) {
    if (Array.isArray(value)) {
      return '!(' + value.map(encodeValue).join(',') + ')';
    } else if (typeof value === 'object' && value !== null) {
      return '(' + Object.keys(value).sort().map(k => `${k}:${encodeValue(value[k])}`).join(',') + ')';
    } else if (typeof value === 'string') {
      // Always wrap strings in quotes to preserve them as strings
      return `'${value}'`;
    } else if (typeof value === 'boolean') {
      return value ? '!t' : '!f';
    } else {
      return String(value);
    }
  }
  // function risonEncode(data) {
  //   return encodeValue(data);
  // }
  useEffect(() => {
    if (!ref.current) {
      return;
    }
    (async () => {
      const resources = [
        {
          type: "dashboard",
          id: uuid,
        },
      ];

      const token = guestToken || (await dataProvider.fetchGuestToken(resources, []));

      const mergedNativeFilters = {};
      let risonFilters = "";
      if (nativeFilters && nativeFilters.length > 0) {
        nativeFilters.map(formatNativeFilter).forEach((filterObject) => {
          const nativeFilterKey = Object.keys(filterObject)[0];
          mergedNativeFilters[nativeFilterKey] = filterObject[nativeFilterKey];
        });
        risonFilters = encodeValue(mergedNativeFilters);
      }

      //get logged in user filter code
      let user_column = null;
      if(nativeFilters && nativeFilters.length > 0){
        user_column= nativeFilters[0].column;
      }

      await embedDashboard({
        uuid: uuid,
        supersetDomain: domain,
        mountPoint: ref!.current,
        fetchGuestToken: () => Promise.resolve(token),
        dashboardUiConfig: {
          ...uiConfig,
          filters: {
            ...uiConfig.filters,
            native_filters: risonFilters,
          },
        },
        vymoAuthToken: vymoAuthToken,
        user_column: user_column
      }).then(async (dashboard: EmbeddedDashboard) => {
        if (!autosize) {
          setLoading(false);
          ref.current!.style.height = "100%";
          return;
        }
        const { height } = await dashboard.getScrollSize();
        let lastHeight = height;
        const interval = setInterval(async () => {
          const { height, width } = await dashboard.getScrollSize();
          if (lastHeight === height) {
            clearInterval(interval);
            ref.current!.style.height = `${height}px`;
            setLoading(false);
          }
          lastHeight = height;
        }, 1500);

        return () => {
          clearInterval(interval);
          dashboard.unmount();
        };
      });
    })();
  }, [ref.current, uuid]);

  return (
    <>
      {placeholder !== false && loading === true && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
          }}
        >
          {placeholder}
        </div>
      )}
      <div className={`superset-dashboard`} ref={ref} style={{ height: 0 }} />
    </>
  );
};

export default Dashboard;
